<div id="pendingSale">
  <pending-sale-block *ngIf="showMyShoppingInMobile$() | async"></pending-sale-block>
</div>
